import { TableCell } from '@mui/material';
import { styled } from '@mui/material/styles';

import palette from '../layout/ColorPalette';

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
    padding: theme.spacing(0.5),
    paddingLeft: theme.spacing(1),
}));

export const StyledHeaderCell = styled(TableCell)(({ theme }) => ({
    padding: theme.spacing(1),
    backgroundColor: palette.primary,
    color: palette.neutral[100],
}));
